<template>
  <div class="md-layout md-alignment-top-center" style="width: 60%; margin: 0 auto">
    <md-card>
      <md-card-header style="font-size: 20px; font-weight: 500">
        {{$t('challengePage.createChallenge')}}
      </md-card-header>
      <md-card-content class="md-layout-item md-size-100" style="margin: 0 auto; overflow-y: auto">
        <ValidationObserver v-slot="{ handleSubmit }" ref="validator">
        <form style="width: 100%" @submit.prevent="handleSubmit(createChallenge)">
          <div class="border-bottom">
            <drag-and-drop-component
                :titleImage="challenge.titleImage"
                :allowMultiple="true"
                @photoSet="onFileChange($event)"
            ></drag-and-drop-component>
        </div>

          <div style="padding: 10px 0;">
            <ValidationProvider
                name="title"
                rules="required"
                v-slot="{ passed, failed }"
            >
            <label>Challenge title <span class="asterisk">*</span></label>
            <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
              <label>Title</label>
              <md-input v-model="challenge.title"></md-input>
            </md-field>
              <slide-y-down-transition style="margin-left: 35px">
                <md-icon class="error" v-show="failed">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition style="margin-left: 35px">
                <md-icon class="success" v-show="passed">done</md-icon>
              </slide-y-down-transition>
            </ValidationProvider>
          </div>

          <md-field style="padding: 10px 0;">
            <label>Bewerb <span class="asterisk">*</span></label>
            <md-select v-model="challenge.activityType">
              <md-option
                  v-for="item in activityTypes"
                  :key="item.number"
                  :label="item.type"
                  :value="item.number"
              >
                {{$t(`activityTypes.${item.type}`)}}
              </md-option>
            </md-select>
          </md-field>

          <div class="md-layout row border-bottom">
            <label>Date <span class="asterisk">*</span></label>
            <div style="display:flex; flex-direction: column; flex-flow: nowrap; width: 100%">
              <div style="padding-left: 0" class="md-layout-item">
                <md-field>
                  <label>Date range</label>
                  <md-select v-model="selectedDateType">
                    <md-option value="day">Tag</md-option>
                    <md-option value="week">Woche</md-option>
                    <md-option value="weekend">Wochenende</md-option>
                    <md-option value="month">Monat</md-option>
                    <md-option value="freeDate">Freied datum</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item">
                <ValidationProvider
                    name="start"
                    rules="required"
                    v-slot="{ passed, failed }"
                >
                <label :class="[{ 'md-error': failed }, { 'md-valid': passed }]">Start</label>
                <md-field class="date-time" :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                  <datetime
                      type="date"
                      v-model="challenge.start"
                      input-class="form-control"
                      format="dd.MM.yyyy"
                      :disabled="disableDatePicker"
                  ></datetime>
                </md-field>
                </ValidationProvider>
              </div>
              <div style="padding-right: 0;" class="md-layout-item">
                <ValidationProvider
                    name="end"
                    rules="required"
                    v-slot="{ passed, failed }"
                >
                <label :class="[{ 'md-error': failed }, { 'md-valid': passed }]">End</label>
                <md-field class="date-time" disabled="true" :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                  <datetime
                      type="date"
                      v-model="challenge.end"
                      input-class="form-control"
                      format="dd.MM.yyyy"
                      :disabled="disableDatePicker"
                      required
                  ></datetime>
                </md-field>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <!--Invite Friends-->
          <div class="md-layout-item border-bottom" style="display: flex">
            <div class="invite-friends">
              <label>Freunde einladen <span class="asterisk">*</span></label>
              <div @click="showFriendsModal=true" style="cursor: pointer">
                <md-icon class="dark-gray">person_add</md-icon>
                <span class="blue-color invite-button-text">Freunde einladen</span>
              </div>
            </div>
            <stacked-users v-if="invitedUsers.length" :users="invitedUsers" :displayText="true" @openModal="openUserModal"></stacked-users>
          </div>
          <!--Description-->
          <md-field style="padding: 10px 0;">
            <label>Challenge description</label>
            <md-textarea
                v-model="challenge.description"
            ></md-textarea>
          </md-field>
        </form>
        </ValidationObserver>
      </md-card-content>

      <md-card-actions>
        <md-button @click="cancelCreatePrivateChallenge">Abbrechen</md-button>
        <md-button class="md-success" @click="createChallenge">Jetzt starten</md-button>
      </md-card-actions>
    </md-card>

    <modal v-if="showFriendsModal" :show.sync="closeModal">
      <template slot="header">
        <div class="md-layout">
          <div class="md-layout-item md-size-90">
            <span style="font-size: 20px; font-weight: 500">Freunde einladen</span>
          </div>
          <div class="md-layout-item md-size-10" @click="closeModal">
            <md-icon >close</md-icon>
          </div>
        </div>
      </template>
      <template slot="body" >
        <users-list
          :showButton="true" :preselectedFriends="preselectedFriends"
          :friends="friends"
          @onCancelInvite="cancelInvite($event)"
          @onSendInvite="sendInvite($event)"
        ></users-list>
      </template>
    </modal>
  </div>
</template>

<script>
import activity from '@/utils/activity'
import { Datetime } from "vue-datetime";
import datetime from "@/utils/datetime";
import UsersList from "sports4me-web_components/atomic-design/molecules/users-list";
import {Modal} from '@/components';
import StackedUsers from "sports4me-web_components/atomic-design/molecules/stacked-users";
import DragAndDropComponent from 'sports4me-web_components/atomic-design/molecules/drag-and-drop-component';
import { extend } from 'vee-validate';
import { required } from "vee-validate/dist/rules";
import UserListModal from "sports4me-web_components/atomic-design/molecules/UserListModal";
extend("required", required);
export default {
  components: {
    datetime: Datetime,
    UsersList,
    Modal,
    StackedUsers,
    DragAndDropComponent,
  },
  data() {
    return {
      activityTypes: activity.getActivitiesWithValidData(),
      selectedDateType: null,
      disableDatePicker: false,
      showFriendsModal: false,
      preselectedFriends: [],
      friends: [],
      selectedFriends: [],
      invitedUsers: [],
      challenge: {
        activityType: 1,
        titleImage: null,
        title: null, // Required
        start: null, // Required
        end: null, // Required
        public: false,
        description: null,
        invited: [], // Required
      },
    }
  },
  mounted() {
    this.selectedDateType = 'day';
    this.$store
        .dispatch("queryAPI", {url: "/rest/user/myFriends"})
        .then(res => {
          this.friends = res;
        })
        .catch(err => {
          this.$notify({
            timeout: 5000,
            message: err.message,
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
        });
  },
  watch: {
    selectedDateType(val) {
      this.disableDatePicker = val != 'freeDate';
      const date = new Date();

      const nextSunday = new Date();
      nextSunday.setDate(nextSunday.getDate() + (0 - 1 - nextSunday.getDay() + 7) % 7 + 1);
      const nextSaturday = new Date();
      nextSaturday.setDate(nextSaturday.getDate() + (6 - 1 - nextSaturday.getDay() + 7) % 7 + 1);
      switch (val) {
        case 'day':
          const d = new Date()
          this.challenge.start =
              this.formatDateForCalendar(
                  new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1));
          this.challenge.end =
              this.formatDateForCalendar(
                  new Date(
                      d.getFullYear(),
                      d.getMonth(),
                      d.getDate() + 1,
                      23,
                      59,
                      59,
                      999
                  )
              );
          break;

        case 'week':
          this.challenge.start = this.formatDateForCalendar(
              new Date(nextSunday.getFullYear(), nextSunday.getMonth(), nextSunday.getDate() + 1)
          );

          this.challenge.end = this.formatDateForCalendar(
              new Date(nextSunday.getFullYear(), nextSunday.getMonth(), nextSunday.getDate() + 7)
          )
          break;

        case 'weekend':
          if (nextSaturday.getDate() === date.getDate()) {
            this.challenge.start = this.formatDateForCalendar(
                new Date(nextSunday.getFullYear(), nextSunday.getMonth(), nextSunday.getDate() + 7)
            );
            this.challenge.end = this.formatDateForCalendar(
                new Date(nextSunday.getFullYear(), nextSunday.getMonth(), nextSunday.getDate() + 8)
            );
            return;
          }
          if (nextSunday.getDate() === date.getDate()) {
            this.challenge.start = this.formatDateForCalendar(
                new Date(nextSunday.getFullYear(), nextSunday.getMonth(), nextSunday.getDate() + 6)
            );
            this.challenge.end = this.formatDateForCalendar(
                new Date(nextSunday.getFullYear(), nextSunday.getMonth(), nextSunday.getDate() + 7)
            );
            return;
          } else {
            this.challenge.start = this.formatDateForCalendar(
                new Date(nextSunday.getFullYear(), nextSunday.getMonth(), nextSunday.getDate() - 1)
            );
            this.challenge.end = this.formatDateForCalendar(
                new Date(nextSunday.getFullYear(), nextSunday.getMonth(), nextSunday.getDate())
            );
          }
          break;

        case 'month':
          this.challenge.start = this.formatDateForCalendar(
              new Date(date.getFullYear(), date.getMonth() + 1, 1)
          );
          this.challenge.end = this.formatDateForCalendar(
              new Date(date.getFullYear(), date.getMonth() + 2, 0)
          );
          break;
        case 'freeDate':
          this.challenge.start = null;
          this.challenge.end = null;
          break;
        default:
          console.log(`Case ${val} not handled!`);
      }
    }
  },
  methods: {
    ...activity,
    ...datetime,
    formatDateForCalendar(date) {
      let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-')
    },
    formatDateForBackend(date) {
      if (date) {
        let formattedDate = new Date(date);
        formattedDate.setUTCHours(23);
        formattedDate.setUTCMinutes(59);
        formattedDate.setUTCSeconds(59);
        formattedDate.setUTCMilliseconds(999);

        return formattedDate.toISOString();
      }
    },
    onFileChange(e) {
      this.challenge.titleImage = e;
    },
    openUserModal() {
      this.$modal.show(
        UserListModal,
        {
          users: this.invitedUsers,
        },
      );
    },
    validate() {
      return this.$refs.validator.validate();
    },
    createChallenge() {
      this.challenge.end = this.formatDateForBackend(this.challenge.end)
      this.challenge.invited = this.selectedFriends;
      const data = this.challenge;
      return this.validate().then(isValid => {
        if (isValid) {
          if (this.challenge.invited.length > 0) {
            this.$store
                .dispatch("postAPI", {
                  url: '/rest/challenge/createPrivateChallenge',
                  data: data
                })
                .then(res => {
                  this.$router.push('/Challenges');
                  this.$notify({
                    timeout: 5000,
                    message: "Erfolgreich gespeichert",
                    type: "success",
                    horizontalAlign: "right",
                    verticalAlign: "top",
                  });
                })
                .catch(err => {
                  this.$notify({
                    timeout: 5000,
                    message: err.message,
                    type: "error",
                    horizontalAlign: "right",
                    verticalAlign: "top",
                  });
                });
          } else {
            this.$notify({
              timeout: 5000,
              message: "Fordere mindestens einen Freund heraus",
              type: "error",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          }
        } else {
          this.$notify({
            timeout: 5000,
            message:
                "Die Pflichtfelder mit * müssen ausgefüllt sein damit du dich anmelden kannst!",
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
        }
      })
    },
    cancelCreatePrivateChallenge() {
      this.$router.push('/Challenges')
    },
    sendInvite(id) {
      this.preselectedFriends.push(id);
      this.invitedUsers = this.friends.filter(a => this.preselectedFriends.includes(a._id))
    },
    cancelInvite(id) {
      this.preselectedFriends = this.preselectedFriends.filter(f => f !== id)
      this.invitedUsers = this.friends.filter(a => this.preselectedFriends.includes(a._id))
    },
    closeModal() {
      this.showFriendsModal = false;
      this.selectedFriends = this.friends.filter(a => this.preselectedFriends.includes(a._id)).map(f => {
        //Mapped only for backend. This model should make the REST call.
        return {
          userId: f._id,
          userDisplayName: f.displayName,
          userImage: f.image,
        }}
      );
    }
  },

}
</script>

<style lang="scss">
.asterisk {
  color: red;
}
.date-time {
  display: flex;
  margin: 0;
  height: 34px;
  padding-right: 0;
  padding-left: 0;
  .md-field:not(.md-disabled):after {
    height: 0;
  }
  .vdatetime {
    flex: 1 1 auto;
    input {
      width: 100%;
      height: 25px;
    }
  }
}

.invite-friends {
  display: flex;
  flex-direction: column;
}

.invite-button-text {
  font-weight: 400;
  font-size: 1rem;
  margin-left: 0.5rem;
}

.border-bottom {
  border-bottom: 1px solid #E0D8D8;
  padding: 10px 0;
}

.md-error {
  color: red
}

md-valid {
  color: #4caf50;
}
:host {
  .date-time {
    padding-right: 0;
    padding-left: 0;
    .md-field:not(.md-disabled):after {
      height: 0;
    }
  }
}
</style>
